var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pessoas"},[_c('v-card',{staticClass:"py-4 px-2 auth-content",attrs:{"tile":""}},[_c('PageTitle',{attrs:{"main":"Painel de notícias","icon":"mdi-pencil-box-outline","sub":"Categorias diversas","home":"/noticias"}}),_c('Categoria')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }